/* Produktseite 2026: unscharfe Kopie des Flaschenfotos als Bühne hinter dem Foto.
   Nur für schmale Einzelflaschen-Fotos. Breitere Fotos (Pakete, Gruppenbilder) bekommen
   die Klasse arns-photo-full und werden ganz und ohne Unschärfe-Rand gezeigt (27.10.2026).
   Rein optisch (aria-hidden); ohne Skript bleibt die Seite unverändert nutzbar. */
(function () {
  /* Einzelflaschen-Fotos haben etwa 0,56 (9:16). Alles ab 0,59 zeigt mehr als eine Flasche (Lagenpaket 0,60). */
  var FULL_FROM_RATIO = 0.59;

  function isFull(box, img) {
    if (document.body.classList.contains('arns-product-paket')) return true;
    var media = box.querySelector('.product-media');
    var ratio = media ? parseFloat(media.style.getPropertyValue('--ratio')) : NaN;
    if (!(ratio > 0) && img.naturalWidth && img.naturalHeight) ratio = img.naturalWidth / img.naturalHeight;
    return ratio >= FULL_FROM_RATIO;
  }

  function stage(root) {
    (root || document).querySelectorAll('.product-information .product-media-container').forEach(function (box) {
      if (box.querySelector('.arns-stage-bg') || box.classList.contains('arns-photo-full')) return;
      var img = box.querySelector('img.product-media__image');
      if (!img) return;
      if (isFull(box, img)) { box.classList.add('arns-photo-full'); return; }
      var src = img.currentSrc || img.src;
      if (!src) return;
      var s = document.createElement('span');
      s.className = 'arns-stage-bg';
      s.setAttribute('aria-hidden', 'true');
      s.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
      box.insertBefore(s, box.firstChild);
    });
  }
  function run() {
    stage();
    document.querySelectorAll('.product-information .product-media-container img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function () { stage(); }, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
